module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Aleksei Tolstoy (1817–1875), cousin of the novelist Lev Tolstoy, is very well known in Russia as a writer of dramas in blank verse and excellent lyrics, in a variety of styles, often set to music. Tchaikovsky chose thirteen of them, with an unerring eye, for eleven of his songs and two of his duets. This is the first of six songs by Rachmaninoff to lyrics of Tolstoy’s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The theme is twilight, the passage from day to evening, in this case a hot day, which carries oppressive implications in the Russian context. So twilight brings relief, and another passage, too, from the present to a memory of the face of the woman the poet loves. Rachmaninoff made a good choice here of a lyric for a song, but he did a poor job of finding music for these words. The restless, rising phrases are at odds with the passage to stillness, to the contemplation of a bond, in this case a tender romantic bond. The long iambic hexameter phrases of the lyric do come across clearly in Rachmaninoff’s use of eighth notes for each syllable in the line until the last one, which is a quarter note, or a dotted quarter note, or a dotted half note; this design culminates in the last word of the second stanza, a whole note high B. But the song searches too strenuously for a convincing melody, and the closing phrase comes as a relief. Singers have not taken the song up: except for the four complete sets of Rachmaninoff’s songs, there are no recordings of it, making it (together with Song 77, a setting of two lines in Church Slavonic from the Gospel of St. John written for the war effort) the composer’s least recorded song.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("T")]), _vm._v("EXT")], 1), _vm._v(". "), _c('b', [_vm._v("Alekséy Konstantínovich Tolstóy")]), _vm._v(", 1856. Untitled. Rachmaninoff removed the first word of the poem, “"), _c('span', {
    staticClass: "font"
  }, [_vm._v("Смеркалось")]), _vm._v(",” and used it as the title of the song; he repeated the first stanza at the end to make it a three-part song. Set by César Cui (Op. 10/3, 1876), the cellist Karl Davydov (Op. 28/5, 1878), and many minor composers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("M")]), _vm._v("ETER")], 1), _vm._v(". Binary. Iambic hexameter (except for the truncated first line), with a caesura after the third foot:")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("M")]), _vm._v("USIC")], 1), _vm._v(". Dated 22 April 1891. Without opus number. G Major. 4/4, [Moderato]. For High Voice: d"), _c('sup', [_vm._v("1")]), _vm._v("–b"), _c('sup', [_vm._v("2")]), _vm._v(". First published posthumously in "), _c('i', [_vm._v("Lamm")]), _vm._v(", 1947. No dedication.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("R")]), _vm._v("ECORDINGS")], 1), _vm._v(". Mazurkevich, Naoumenko, Söderström, Suchkova.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cui: Valentina Sharonova.")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "chtop",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "3%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "87%"
    }
  })]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chno"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('td'), _c('td', [_c('p', {
    staticClass: "cht"
  }, [_c('i', [_vm._v("Смеркалось")])]), _vm._v(" "), _c('p', {
    staticClass: "cht"
  }, [_c('i', [_vm._v("Twilight was falling")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "top",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "50%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "25%"
    }
  })]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Жаркий день бледнел неуловимо")]), _vm._v(",")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Над озером туман тянулся полосой")]), _vm._v(",")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("И кроткий образ твой, знакомый и любимый")]), _vm._v(",")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("В вечерний тихий час носился предо мной.")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Улыбка та же была, которую люблю я")]), _vm._v(",")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("И мягкая коса, как прежде расплелась")]), _vm._v(",")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("И очи грустные, по прежнему тоскуя")]), _vm._v(",")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Глядели на меня в вечерний тихий час.")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Жаркий день бледнел неуловимо")]), _vm._v(",")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Над озером туман тянулся полосой")]), _vm._v(",")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("И кроткий образ твой, знакомый и любимый")]), _vm._v(",")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("В вечерний тихий час носился предо мной")]), _vm._v(",")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("В вечерний тихий час.")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "top",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "45%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "50%"
    }
  })]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Zhárkij dén’ blednél neulavíma,")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("The hot day grew paler imperceptibly,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Nad ózeram tumán tjanúlsa palasój,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("A band of mist stretched out over the lake,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("I krótkij óbras tvój, znakómyj")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("And your gentle image, so familiar")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("i ljubímyj,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("and beloved,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("V vechérnij tíkhij chás nasílsa")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Floated before me in the quiet")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("preda mnój.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("evening hour.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_vm._v("Ulýpka tá zhe bylá, katóruju ljubljú ja,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_vm._v("Your smile was the smile I love so much,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("I mjákhkaja kasá, kak prézhde")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("And your soft braid, as before, came")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("rasplelás’,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("undone,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("I óchi grúsnyje, pa prézhnemu taskúja,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("And your sad eyes, with a look of longing,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Gljadéli na menjá v vechérnij tíkhij")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Were gazing at me in the quiet evening")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("chás.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("hour.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_vm._v("Zhárkij dén’ blednél neulavíma,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_vm._v("The light of a hot day faded imperceptibly,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Nad ózeram tumán tjanúlsa palasój,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("A band of mist stretched out over the lake,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("I krótkij óbras tvój, znakómyj")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("And your gentle image, so familiar")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("i ljubímyj,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("and beloved,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("V vechérnij tíkhij chás nasílsa")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Floated before me in the quiet evening")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("preda mnój,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("hour,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("V vechérnij tíkhij chás.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("In the quiet evening hour.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "left"
  }, [_c('i', [_vm._v("You smiled your lovely smile, your soft braid came undone…")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d8bfc36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/017_Chapter_05.vue
// module id = 105
// module chunks = 0